// One source of truth for how a rate's source is labeled and badged, shared by
// the rate-search page and the on-shipment booking drawer. A rate is a rate; the
// source just gets marked. Mirrors Rates::Offer::SOURCE_LABELS on the backend.

const LABELS: Record<string, string> = {
  api: 'API rate',
  manual: 'Manual rate',
  rate_sheet: 'Contract',
}

const BADGE_CLASSES: Record<string, string> = {
  api: 'bg-blue-50 text-blue-700',
  manual: 'bg-blue-50 text-blue-700',
  rate_sheet: 'bg-violet-100 text-violet-700',
}

export function rateSourceLabel(source?: string | null): string | null {
  return source ? LABELS[source] ?? null : null
}

export function rateSourceBadgeClass(source?: string | null): string {
  return (source && BADGE_CLASSES[source]) || 'bg-blue-50 text-blue-700'
}
